/*
  GPT (Google Publisher Tag) is configured in Tealium to inject
  the marketing tiles into the DIV containers we provided on the dash.

  At the moment unfortunately, these tiles are not responsive.

  Once loaded, we get a callback from within the GPT tag.
  To deal with making the images in the creatives responsive
  we're currently doing the below hack to set their width/height
  in the callback.

  We are investigasting how to set up 'native' (fluid) ads,
  but it's a bit of an ongoing investigation with Simon and Hagan.
*/

const handleGptTagLoaded = () => {
  const frames = document.querySelectorAll<HTMLIFrameElement>(
    '[data-google-container-id]',
  );

  frames.forEach((frame: HTMLIFrameElement) => {
    const frameDocument =
      frame.contentDocument || frame.contentWindow?.document;
    if (!frameDocument) {
      return;
    }

    const images = frameDocument.getElementsByClassName('img_ad');
    if (!images || !images.length) {
      return;
    }

    for (const image of Object.entries(images)) {
      const img = image[1] as HTMLImageElement;
      img.style.width = '100%';
      img.style.height = '100%';
    }
  });
};

export const configureGPTCallback = () => {
  window.handleGptDisplay = handleGptTagLoaded;
};
